import { cn } from "@/lib/utils";
import {
  SITE_CONTAINER_CLASS,
  SITE_CONTAINER_WIDE_CLASS,
} from "@/lib/constants";

type ContainerProps = {
  children: React.ReactNode;
  className?: string;
  as?: "div" | "section" | "header" | "footer";
  id?: string;
  wide?: boolean;
};

export default function Container({
  children,
  className,
  as: Tag = "div",
  id,
  wide,
}: ContainerProps) {
  return (
    <Tag
      id={id}
      className={cn(
        "mx-auto w-full px-5 md:px-8",
        wide ? SITE_CONTAINER_WIDE_CLASS : SITE_CONTAINER_CLASS,
        className,
      )}
    >
      {children}
    </Tag>
  );
}
